import React from 'react'

import MyBanner from '../components/MyBanner'

function NotFoundPage() {
  return (
    <>
      <MyBanner title="找不到網頁" lead="找不到網頁頁面" />
    </>
  )
}

export default NotFoundPage
